var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import Card from 'src/components/Card/Card.vue';
import { mapActions } from 'vuex';
import GenericTable from 'src/components/GenericTable/GenericTable.vue';
export default Vue.extend({
    components: { Card },
    data() {
        return {
            login: null,
            name: null,
            email: null,
            password: null,
            password_confirmation: null,
            send_email: false
        };
    },
    computed: {
        submitDisabled() {
            return !this.password || (this.password_confirmation !== this.password) || !this.login || !this.name;
        }
    },
    methods: Object.assign(Object.assign({}, mapActions({
        'usersCreate': 'users.users/usersCreate'
    })), { submit() {
            return __awaiter(this, void 0, void 0, function* () {
                const user = {
                    login: this.login,
                    name: this.name,
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                    app_id: this.$store.state.authorizedUser.currentAppObject.id,
                    tenant_id: this.$store.state.authorizedUser.currentTenantObject.id,
                    org_id: this.$store.state.authorizedUser.currentOrgObject.id,
                    send_email: this.send_email
                };
                const response = yield this.usersCreate(user); // await this.$store.dispatch('users.users/create', user)
                if (response.data[0].id > 0) { // user has been created and ID assigned
                    this.$q.notify({ message: 'User has been created. But it has no access rights by default. Click on the created profile, and assign appropriate roles to it.', color: 'blue' });
                    this.$store.dispatch('mode/setCurrentMode', { component: GenericTable, componentProps: { localEntityNameProp: 'users.users', startingSortingModelProp: [{ application_order: 1, field: 'created_at', direction: 'desc' }, { application_order: 2, field: 'name', direction: 'asc' }], startingFilterModelProp: [{ field: 'deactivated', predicate: 'containedIn', value: ['false'] }] } });
                }
            });
        } })
});
